// extracted by mini-css-extract-plugin
export default {"btnChooseFilterDate":"Shipment_btnChooseFilterDate__4V-22"};